import { TableCell, TableHead, TableRow, TextField } from '@material-ui/core';
import Select from 'react-select';
import styled, { css } from 'styled-components';
import { StyledIconButton, StyledButton, GutterCSS, PaddingCSS } from 'styles/common';

export const StyledIconButton1 = styled(StyledIconButton)`
  width: 28px !important;
  height: 28px !important;
  svg {
    height: 0.8em;
    width: 0.8em;
  }
  ${(props) =>
    props.disabled &&
    css`
      span {
        opacity: 0.4;
      }
    `}
`;

export const StyledTextField = styled(TextField)`
  input {
    font-size: 0.875rem;
    padding: 8px 0;
    color: ${(props) => props.color ?? 'inherit'};
    ${PaddingCSS};
  }
  input:disabled {
    color: ${(props) => (props.color ? props.color : props.theme.palette.text.primary)};
  }
  fieldset {
    border: none;
  }

  ${(props) =>
    props.$truncateText &&
    css`
      input {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    `}

  ${GutterCSS}
`;

export const StyledButton1 = styled(StyledButton)`
  p {
    font-size: 0.875rem;
  }
  ${(props) =>
    props.disabled &&
    css`
      span {
        opacity: 0.4;
      }
    `}
`;

export const SkeletonContainer = styled.div`
  padding: 1.5rem 1.5rem;
`;

export const StyledTableRow = styled(TableRow)`
  background: ${(props) => props.theme.palette.background.paper};
  ${(props) =>
    props.isEditing &&
    css`
      td {
        border-bottom: 2px solid ${(props) => props.theme.palette.primary.main};
      }
      background: ${(props) => props.theme.palette.background.lighterBlue};
    `}
`;

export const StyledTableHead = styled(TableHead)`
  background: ${(props) => props.theme.palette.background.paper};
  margin-bottom: 1rem;

  th {
    border-bottom: 1px solid #eaeaea;
  }
`;

const paddingCSS = css`
  ${(props) =>
    props.paddingLeft &&
    css`
      padding-left: ${props.paddingLeft};
    `};
  ${(props) =>
    props.paddingRight &&
    css`
      padding-right: ${props.paddingRight};
    `};
  // earlier by mistake we didn't use camelcase, so keeping it for backward compatibility
  ${(props) =>
    props.paddingtop &&
    css`
      padding-top: ${props.paddingtop};
    `};
  ${(props) =>
    props.paddingTop &&
    css`
      padding-top: ${props.paddingTop};
    `};
  ${(props) =>
    props.paddingBottom &&
    css`
      padding-bottom: ${props.paddingBottom};
    `};
  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `};
`;

export const StyledTableCell = styled(TableCell)`
  position: relative;
  width: ${(props) => props.width || 'auto'};
  text-align: ${(props) => props.textAlign || 'left'};
  padding: 5px 24px 5px 16px;
  ${paddingCSS};
  border-bottom: ${(props) => (props.border ? `1px solid #EAEAEA` : 'none')};
  ${(props) =>
    props.compact &&
    css`
      padding: 0.5em 0;
      line-height: 0;
    `}
`;

export const HeaderTableCell = styled(TableCell)`
  color: ${(props) => props.theme.palette.text.label};
  ${paddingCSS};
  line-height: 1rem;
  ${(props) =>
    props.$isSticky &&
    css`
      top: 73px;
      z-index: 10;
    `}
`;

export const StyledSelectDropdown = styled(Select)`
  .driver-select__control {
    height: 40px;
  }
  ${(props) =>
    !props.isEditing &&
    !props.isRenaming &&
    css`
      .driver-select__control {
        border-color: transparent;
        background-color: transparent;
      }
      .driver-select__indicator-separator {
        visibility: hidden;
      }
      .driver-select__dropdown-indicator {
        visibility: hidden;
      }
      .driver-select__control:hover .driver-select__dropdown-indicator,
      .driver-select__control:hover .driver-select__indicator-separator {
        visibility: visible;
      }
    `}
  .driver-select__option--is-selected {
    background-color: ${(props) => props.theme.palette.background.blue.light.v2};
  }
  .driver-select__single-value {
    font-size: 14px;
  }
  .driver-select__placeholder {
    font-size: 14px;
  }
  .MuiChip-root {
    vertical-align: inherit;
  }
`;
